import { Component, OnInit, Input, Output, ViewEncapsulation, EventEmitter, ViewChild, NgZone } from '@angular/core';
import { MapLocation } from '@app/modules/map-location-selection/components/select-location-body/select-map-location.models';

@Component({
    selector: 'topo-select-location',
    templateUrl: './select-location.component.html',
    styleUrls: ['./select-location.component.scss'],
    standalone: false
})
export class SelectMapLocationComponent implements OnInit {
  @Input() isActive: boolean;
  @Input() location?: MapLocation;
  @Output() saveLocation = new EventEmitter<MapLocation>();
  @Output() cancelLocation = new EventEmitter();

  constructor() { }

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  selectedLocation: MapLocation;

  cancelClick(): void {
    this.cancelLocation.emit();
  }

  saveClick(): void {
    this.saveLocation.emit(this.selectedLocation);
  }

  selectedPinLocation(location: MapLocation): void {
    this.selectedLocation = location;
  }
}
